import type { SVGProps } from 'react';
import * as React from 'react';

const SvgStepIncomplete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="100%"
    stroke="currentColor"
    strokeWidth={1.5}
    viewBox="0 0 16 16"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M.75 8a7.25 7.25 0 1 1 14.5 0A7.25 7.25 0 0 1 .75 8Z" />
    <circle cx={8} cy={8} fill="#CFD4DE" r={4} />
  </svg>
);
export default SvgStepIncomplete;
